/**
 * PageHeader - consistent page/section title block.
 *
 * Props:
 *   title       (node, required)
 *   subtitle    (node, optional)
 *   action      (node, optional) - e.g. a primary button, right-aligned
 *   sx          (object, optional)
 */

import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const PageHeader = ({ title, subtitle, action, sx }) => (
  <Box sx={{ mb: { xs: 3, md: 4 }, ...sx }}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
    >
      <Box>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 800, fontFamily: '"Playfair Display", serif' }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Stack>
  </Box>
);

export default PageHeader;
